/**
 * Identity fields that define a saved address book entry. Editing any of these
 * means the stop no longer matches its saved address, so the applied-address
 * link (`addressBookItemId`) must be cleared.
 *
 * This set is intentionally the SAME set compared by `findMatchingAddressBookItem`
 * on quote reload, so an in-session edit and a reload reconstruction agree on
 * what "pristine" means. Contact / hours / PO fields are deliberately excluded:
 * they are not part of the address identity or the search-box label.
 *
 * Kept in its own dependency-free module so the address context (which enforces
 * the invariant) never has to import any UI/display code.
 */
export const IDENTITY_ADDRESS_FIELDS: ReadonlySet<string> = new Set([
	"companyName",
	"address1",
	"address2",
	"postalCode",
	"city",
	"stateProvince",
]);
